import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { List_Attendance_Types, Add_Update_Attendance_Types, GET_ROLE_DETAILS, Role_Management, Role_Account_Query } from "../../../../../services/userAPI";
import { IoClose } from "react-icons/io5";
import { Button, message, Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "./attendanceDailyNorm.css";
import DailyNormConfiguration from "./dailyNormConfiguration";
import backIcon from '../../../../../Images/addstarsbackIcon.png';
// import PageBreadcrumb from "../../../../../reusableField/PageBreadcrumb";
import ButtonAlignment from "../userManagement/buttonalignment";
import BackIcon from "../../../../../Images/backIcon.png";
import HomeIcon from "../../../../../Images/homeIcon.png";

const AttendanceDailyNorm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("attendance-daily-norm");
    const [activeAttendanceTab, setActiveAttendanceTab] = useState("attendance-daily-norm");

    const getActiveTabFromPath = () => {
        if (location.pathname.includes("masterConfiguration")) return "masters-configuration";
        if (location.pathname.includes("user-management")) return "user-management";
        if (location.pathname.includes("mark-holidays")) return "holidays";
        return "attendance-daily-norm";
    };

    useEffect(() => {
        setActiveTab(getActiveTabFromPath());

        if (location.pathname.includes("mark-holidays")) {
            setActiveAttendanceTab("holidays");
        } else {
            setActiveAttendanceTab("attendance-daily-norm");
        }
    }, [location.pathname]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (key === "masters-configuration") {
            navigate("/masterConfiguration", { state: { roleId, accountId, name, accountName } });
        } else if (key === "user-management") {
            navigate("/user-management", { state: { roleId, accountId, name, accountName } });
        } else if (key === "holidays") {
            navigate("/mark-holidays", { state: { roleId, accountId, name, accountName } });
        } else {
            navigate("/attendance-daily-norm", { state: { roleId, accountId, name, accountName } });
        }
    };
    const [signInMethod, setSignInMethod] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [signInRequired, setSignInRequired] = useState(false);
    const [locationRequired, setLocationRequired] = useState(false);
    const [geoTrackingRequired, setGeoTrackingRequired] = useState(false);
    const [mandatoryTimeDistribution, setMandatoryTimeDistribution] = useState(false);

    // State from location
    const accountId = location.state?.accountId || null;
    const roleId = location.state?.roleId || null;
    const name = location.state?.name || "";
    const accountName = location.state?.accountName || "";
    const dartsFormNeeded = location.state?.dartsFormNeeded || false;
    const pocName = location.state?.pocName || "";
    const pocEmail = location.state?.pocEmail || "";
    const pocNumber = location.state?.pocNumber || "";
    const numberLogin = location.state?.numberLogin || false;
    const emailLogin = location.state?.emailLogin || false;
    const targetEditDays = location.state?.targetEditDays || 0;
    const inputEditDays = location.state?.inputEditDays || 0;
    const dartsNeeded = location.state?.dartsNeeded || false;
    const clanNeeded = location.state?.clanNeeded || false;
    const syncNeeded = location.state?.syncNeeded || false;
    const ldmsNeeded = false;
    const mirrorNeeded = false;
    const jobroleAccessUserIds = [];

    // Fetch Attendance Types
    const { loading, error, data, refetch } = useQuery(List_Attendance_Types, {
        variables: { accountId, jobRoleId: roleId },
        skip: !accountId || !roleId,
    });

    // ✅ CORRECT
    const { data: roleDataa } = useQuery(Role_Account_Query, {
        variables: { accountId: accountId ? parseInt(accountId) : null },
        fetchPolicy: "network-only",
        skip: !accountId,
    });
    const currentRole = roleDataa?.getAllJobrole?.find((r) => r.id === roleId);
    const safeAccountName = accountName || "";
    const safeRoleName = name || currentRole?.name || "";
    // Fetch Role Details to initialize toggle states
    const { data: roleData, refetch: refetchRoleDetails } = useQuery(GET_ROLE_DETAILS, {
        variables: { jobroleId: parseInt(roleId) },
        skip: !roleId,
        onCompleted: (data) => {
            if (data.getJobrole) {
                setSignInRequired(data.getJobrole.signInSignOutRequired);
                setLocationRequired(data.getJobrole.locationRequired);
                setGeoTrackingRequired(data.getJobrole.geoTracking);
                setMandatoryTimeDistribution(data.getJobrole.mandatoryTimeDistribution);
            } else {
                message.error("Failed to fetch role details");
            }
        },
        onError: (err) => {
            console.error("Error fetching role details:", err);
            message.error("Failed to fetch role details");
        },
    });

    // Add / Update Attendance Type Mutation
    const [addUpdateAttendance, { loading: mutationLoading }] = useMutation(Add_Update_Attendance_Types, {
        onCompleted: (data) => {
            message.success(data.addUpdateAttendanceTypes.message);
            setIsModalOpen(false);
            setSignInMethod("");
            setEditingId(null);
            refetch();
        },
        onError: (err) => {
            console.error("Error:", err);
            message.error("Failed to save sign-in method");
        },
    });

    // Role Management Mutation
    const [addJobRole, { loading: roleMutationLoading }] = useMutation(Role_Management, {
        onCompleted: (data) => {
            if (data.addJobrole.success) {
                // message.success(data.addJobrole.message);
                // Refetch role details to update toggle states
                refetchRoleDetails();
            } else {
                message.error(data.addJobrole.message);
                // Refetch role details to ensure toggles reflect server state
                refetchRoleDetails();
            }
        },
        onError: (err) => {
            console.error("Error updating role:", err);
            message.error("Failed to update role settings");
            // Refetch role details to ensure toggles reflect server state
            refetchRoleDetails();
        },
    });

    // Handle Sign-In Required Toggle and Call Mutation
    const handleSignInRequiredChange = (checked) => {
        setSignInRequired(checked);

        // Reset dependent states when unchecking
        let newLocationRequired = checked ? (locationRequired || false) : false;
        let newGeoTrackingRequired = checked ? (geoTrackingRequired || false) : false;
        let newMandatoryTimeDistribution = checked ? (mandatoryTimeDistribution || false) : false;

        if (!checked) {
            newLocationRequired = false;
            newGeoTrackingRequired = false;
            newMandatoryTimeDistribution = false;
        }

        setLocationRequired(newLocationRequired);
        setGeoTrackingRequired(newGeoTrackingRequired);
        setMandatoryTimeDistribution(newMandatoryTimeDistribution);

        // Call the Role_Management mutation with all required fields from roleData
        const currentRole = roleData?.getJobrole;
        addJobRole({
            variables: {
                accountId: parseInt(accountId),
                name: currentRole?.name || name || "",
                clanNeeded: currentRole?.clanNeeded,
                syncNeeded: currentRole?.syncNeeded,
                dartsNeeded: currentRole?.dartsNeeded,
                dartsFormNeeded: currentRole?.dartsFormNeeded,
                geoTracking: newGeoTrackingRequired,
                jobroleId: roleId ? parseInt(roleId) : null,
                pocName: currentRole?.pocName,
                pocEmail: currentRole?.pocEmail,
                pocNumber: currentRole?.pocContactNumber,
                numberLogin: currentRole?.numberLogin,
                emailLogin: currentRole?.emailLogin,
                mandatoryTimeDistribution: newMandatoryTimeDistribution,
                signInSignOutRequired: checked,
                locationRequired: newLocationRequired,
                targetEditDays: currentRole?.targetEditDays,
                inputEditDays: currentRole?.inputEditDays,
                jobroleAccessUserIds: currentRole?.jobroleAccessUsers?.map(u => u.id) || [],
                ldmsNeeded: currentRole?.ldmsNeeded,
                mirrorNeeded: currentRole?.mirrorNeeded,
            },
            onCompleted: (data) => {
                if (data.addJobrole.success) {
                    message.success(
                        checked
                            ? "Sign-In / Sign-Out enabled successfully"
                            : "Sign-In / Sign-Out disabled successfully"
                    );
                    refetchRoleDetails();
                }
            },
            onError: (err) => {
                console.error("Error:", err);
                message.error("Failed to update Sign-In / Sign-Out setting");
                refetchRoleDetails();
            },
        });
    };

    // Handle Location Required Toggle and Call Mutation
    const handleLocationRequiredChange = (checked) => {
        setLocationRequired(checked);

        // Reset dependent states when unchecking
        let newGeoTrackingRequired = checked ? (geoTrackingRequired || false) : false;
        let newMandatoryTimeDistribution = checked ? (mandatoryTimeDistribution || false) : false;

        if (!checked) {
            newGeoTrackingRequired = false;
            newMandatoryTimeDistribution = false;
        }

        setGeoTrackingRequired(newGeoTrackingRequired);
        setMandatoryTimeDistribution(newMandatoryTimeDistribution);

        // Call the Role_Management mutation with all required fields from roleData
        const currentRole = roleData?.getJobrole;
        addJobRole({
            variables: {
                accountId: parseInt(accountId),
                name: currentRole?.name || name || "",
                clanNeeded: currentRole?.clanNeeded,
                syncNeeded: currentRole?.syncNeeded,
                dartsNeeded: currentRole?.dartsNeeded,
                dartsFormNeeded: currentRole?.dartsFormNeeded,
                geoTracking: newGeoTrackingRequired,
                jobroleId: roleId ? parseInt(roleId) : null,
                pocName: currentRole?.pocName,
                pocEmail: currentRole?.pocEmail,
                pocNumber: currentRole?.pocContactNumber,
                numberLogin: currentRole?.numberLogin,
                emailLogin: currentRole?.emailLogin,
                mandatoryTimeDistribution: newMandatoryTimeDistribution,
                signInSignOutRequired: signInRequired,
                locationRequired: checked,
                targetEditDays: currentRole?.targetEditDays,
                inputEditDays: currentRole?.inputEditDays,
                jobroleAccessUserIds: currentRole?.jobroleAccessUsers?.map(u => u.id) || [],
                ldmsNeeded: currentRole?.ldmsNeeded,
                mirrorNeeded: currentRole?.mirrorNeeded,
            },
            onCompleted: (data) => {
                if (data.addJobrole.success) {
                    message.success(
                        checked
                            ? "Location requirement enabled successfully"
                            : "Location requirement disabled successfully"
                    );
                    refetchRoleDetails();
                }
            },
            onError: (err) => {
                console.error("Error:", err);
                message.error("Failed to update Location requirement");
                refetchRoleDetails();
            },
        });
    };

    const handleGeoTrackingRequiredChange = (checked) => {
        setGeoTrackingRequired(checked);

        // Reset dependent toggle if unchecking
        let newMandatoryTimeDistribution = checked ? (mandatoryTimeDistribution || false) : false;
        if (!checked) {
            newMandatoryTimeDistribution = false;
            setMandatoryTimeDistribution(false);
        }

        // Call the Role_Management mutation with all required fields from roleData
        const currentRole = roleData?.getJobrole;
        addJobRole({
            variables: {
                accountId: parseInt(accountId),
                name: currentRole?.name || name || "",
                clanNeeded: currentRole?.clanNeeded,
                syncNeeded: currentRole?.syncNeeded,
                dartsNeeded: currentRole?.dartsNeeded,
                dartsFormNeeded: currentRole?.dartsFormNeeded,
                geoTracking: checked,
                jobroleId: roleId ? parseInt(roleId) : null,
                pocName: currentRole?.pocName,
                pocEmail: currentRole?.pocEmail,
                pocNumber: currentRole?.pocContactNumber,
                numberLogin: currentRole?.numberLogin,
                emailLogin: currentRole?.emailLogin,
                mandatoryTimeDistribution: newMandatoryTimeDistribution,
                signInSignOutRequired: signInRequired,
                locationRequired: locationRequired,
                targetEditDays: currentRole?.targetEditDays,
                inputEditDays: currentRole?.inputEditDays,
                jobroleAccessUserIds: currentRole?.jobroleAccessUsers?.map(u => u.id) || [],
                ldmsNeeded: currentRole?.ldmsNeeded,
                mirrorNeeded: currentRole?.mirrorNeeded,
            },
            onCompleted: (data) => {
                if (data.addJobrole.success) {
                    message.success(
                        checked
                            ? "Geo-Tracking enabled successfully"
                            : "Geo-Tracking disabled successfully"
                    );
                    refetchRoleDetails();
                }
            },
            onError: (err) => {
                console.error("Error:", err);
                message.error("Failed to update Geo-Tracking setting");
                refetchRoleDetails();
            },
        });
    };

    // Handle Mandatory Time Distribution Toggle and Call Mutation
    const handleMandatoryTimeDistributionChange = (checked) => {
        setMandatoryTimeDistribution(checked);

        // Call the Role_Management mutation with all required fields from roleData
        const currentRole = roleData?.getJobrole;
        addJobRole({
            variables: {
                accountId: parseInt(accountId),
                name: currentRole?.name || name || "",
                clanNeeded: currentRole?.clanNeeded,
                syncNeeded: currentRole?.syncNeeded,
                dartsNeeded: currentRole?.dartsNeeded,
                dartsFormNeeded: currentRole?.dartsFormNeeded,
                geoTracking: geoTrackingRequired,
                jobroleId: roleId ? parseInt(roleId) : null,
                pocName: currentRole?.pocName,
                pocEmail: currentRole?.pocEmail,
                pocNumber: currentRole?.pocContactNumber,
                numberLogin: currentRole?.numberLogin,
                emailLogin: currentRole?.emailLogin,
                mandatoryTimeDistribution: checked,
                signInSignOutRequired: signInRequired,
                locationRequired: locationRequired,
                targetEditDays: currentRole?.targetEditDays,
                inputEditDays: currentRole?.inputEditDays,
                jobroleAccessUserIds: currentRole?.jobroleAccessUsers?.map(u => u.id) || [],
                ldmsNeeded: currentRole?.ldmsNeeded,
                mirrorNeeded: currentRole?.mirrorNeeded,
            },
            onCompleted: (data) => {
                if (data.addJobrole.success) {
                    message.success(
                        checked
                            ? "Mandatory Day-End Sign-Out enabled successfully"
                            : "Mandatory Day-End Sign-Out disabled successfully"
                    );
                    refetchRoleDetails();
                }
            },
            onError: (err) => {
                console.error("Error:", err);
                message.error("Failed to update Mandatory Day-End Sign-Out setting");
                refetchRoleDetails();
            },
        });
    };

    const handleSave = () => {
        setFormSubmitted(true);

        if (!signInMethod.trim()) {
            return;
        }

        if (!accountId || !roleId) {
            message.error("Missing account details!");
            return;
        }

        setErrors("");

        addUpdateAttendance({
            variables: {
                accountId,
                roleId,
                attendanceType: signInMethod,
                status: null,
                attendanceTypeId: editingId || null,
            },
        });
    };

    const handleDelete = (attendanceTypeId) => {
        addUpdateAttendance({
            variables: {
                accountId,
                roleId,
                attendanceType: "",
                status: 0,
                attendanceTypeId,
            },
            onCompleted: (data) => {
                message.success("Deleted successfully!");
                refetch();
            },
            onError: (err) => {
                console.error("Error:", err);
                message.error("Failed to delete sign-in method");
            },
        });
    };

    const handleAddNew = () => {
        setSignInMethod("");
        setEditingId(null);
        setIsModalOpen(true);
    };

    const handleEdit = (item) => {
        setSignInMethod(item.attendanceType);
        setEditingId(item.id);
        setIsModalOpen(true);
    };

    const handleBack = () => {
        navigate("/admin");
    };

    const handleBackToViewRole = () => {
        const safeRoleId = roleId || location.state?.roleId;
        const safeAccountName = accountName || location.state?.accountName;

        navigate("/experience-configuration", {
            state: {
                roleId: safeRoleId,
                accountId,
                accountName: safeAccountName,
                name,
                dartsNeeded,
                clanNeeded,
                syncNeeded,
                dartsFormNeeded,
                pocName,
                pocEmail,
                pocNumber,
                numberLogin,
                emailLogin,
                mandatoryTimeDistribution,
                targetEditDays,
                inputEditDays,
            },
        });
    };

    return (
        <div className="user-profile-container attendance-daily-norm-page">
            <div className=" mx-auto px-3">
                <div className=" mx-auto px-3">
                    <div className="flex justify-between items-center w-full  mx-[-20px]">

                        {/* Back Button */}
                        <button
                            onClick={handleBackToViewRole}
                            className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                        >
                            <img
                                src={BackIcon}
                                alt="Back"
                                className="w-[15px] h-[15px] object-contain"
                            />
                            Back
                        </button>

                        {/* Home Button */}
                        <button
                            onClick={() => navigate("/admin")}
                            className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 mr-[-45px] rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                        >
                            <img
                                src={HomeIcon}
                                alt="Home"
                                className="w-[15px] h-[15px] object-contain"
                            />
                            Home
                        </button>

                    </div>

                    <div
                        className="flex items-center text-sm text-[#939393]"
                        style={{ marginTop: 12, marginLeft: "-16px" }}
                    >
                        <span
                            onClick={() => navigate("/admin")}
                            className="cursor-pointer"
                        >
                            {safeAccountName}
                        </span>

                        <span className="mx-2 text-[14px]">›</span>

                        <span
                            onClick={() =>
                                navigate("/admin", {
                                    state: {
                                        roleId,
                                        accountId,
                                        name,
                                        accountName,
                                    },
                                })
                            }
                            className="cursor-pointer"
                        >
                            {safeRoleName}
                        </span>

                        <span className="mx-2 text-[14px]">›</span>

                        {/* Role Name */}

                        <span
                            onClick={() =>
                                navigate("/experience-configuration", {
                                    state: {
                                        roleId,
                                        accountId,
                                        name,
                                        accountName,
                                    },
                                })
                            }
                            className="cursor-pointer"
                        >
                            Experience Configuration
                        </span>

                        <span className="mx-2 text-[14px]">›</span>

                        <span className="font-semibold text-gray-800">
                            Masters Configuration
                        </span>
                    </div>
                </div>
            </div>
            <ButtonAlignment
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onTabChange={handleTabChange}
                hideHolidays={true}
            />

            {/* Attendance Sub Tabs */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "8px",
                    marginBottom: "20px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "295px",
                        borderBottom: "1px solid #D9D9D9",
                    }}
                >
                    {/* Attendance & Daily Norm */}
                    <button
                        type="button"
                        onClick={() => {
                            navigate("/attendance-daily-norm", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                    dartsFormNeeded,
                                    dartsNeeded,
                                    clanNeeded,
                                    syncNeeded,
                                    pocName,
                                    pocEmail,
                                    pocNumber,
                                    numberLogin,
                                    emailLogin,
                                    targetEditDays,
                                    inputEditDays,
                                },
                            });
                        }}
                        style={{
                            flex: 1,
                            background: "transparent",
                            border: "none",
                            borderBottom: "2px solid #C21A17",
                            color: "#C21A17",
                            padding: "0 0 12px 0",
                            fontFamily: "Inter",
                            fontSize: "13px",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Attendance & Daily Norm
                    </button>

                    {/* Mark Holidays */}
                    <button
                        type="button"
                        onClick={() => {
                            navigate("/mark-holidays", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                    dartsFormNeeded,
                                    dartsNeeded,
                                    clanNeeded,
                                    syncNeeded,
                                    pocName,
                                    pocEmail,
                                    pocNumber,
                                    numberLogin,
                                    emailLogin,
                                    targetEditDays,
                                    inputEditDays,
                                },
                            });
                        }}
                        style={{
                            flex: 1,
                            background: "transparent",
                            border: "none",
                            borderBottom: "2px solid transparent",
                            color: "#333333",
                            padding: "0 0 12px 0",
                            fontFamily: "Inter",
                            fontSize: "13px",
                            fontWeight: "500",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Mark Holidays
                    </button>
                </div>
            </div>
            <h3 className="attendance-daily-norm-heading">
                Attendance & Daily Norm
            </h3>
            {/* Toggle Buttons */}
            <div
                style={{
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    backgroundColor: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                }}
            >


                {/* Sign In Required Toggle */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ fontFamily: "Inter", fontSize: "14px" }}>Sign-In / Sign-Out Required</span>
                    <Switch checked={signInRequired} onChange={handleSignInRequiredChange} disabled={roleMutationLoading} />
                </div>

                {/* Location Required Toggle - Shown only if Sign In Required is on */}
                {signInRequired && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontFamily: "Inter", fontSize: "14px" }}>Location Required</span>
                        <Switch checked={locationRequired} onChange={handleLocationRequiredChange} disabled={roleMutationLoading} />
                    </div>
                )}

                {/* Geo-Tracking Toggle - Shown only if Location Required is on */}
                {locationRequired && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontFamily: "Inter", fontSize: "14px" }}>Geo-Tracking</span>
                        <Switch
                            checked={geoTrackingRequired}
                            onChange={handleGeoTrackingRequiredChange}
                            disabled={roleMutationLoading}
                        />
                    </div>
                )}

                {/* Mandatory Day-End Sign-Out Toggle - Shown only if Sign In Required is on */}
                {signInRequired && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontFamily: "Inter", fontSize: "14px" }}>Mandatory Day-End Sign-Out</span>
                        <Switch
                            checked={mandatoryTimeDistribution}
                            onChange={handleMandatoryTimeDistributionChange}
                            disabled={roleMutationLoading}
                        />
                    </div>
                )}
            </div>

            {signInRequired && (
                <div className="attendance-card">
                    <div className="attendance-header">
                        <span className="config-label">Sign-In Method Configuration</span>
                        <button className="add-signin-btn" onClick={handleAddNew}>
                            Add Sign-in Type
                        </button>
                    </div>
                    <div className="attendance-list">
                        {loading ? (
                            <p>Loading...</p>
                        ) : error ? (
                            <p className="error-message">Error: {error.message}</p>
                        ) : (
                            data?.listAttendanceTypes.map((item) => (
                                <div key={item.id} className="attendance-item">
                                    <span className="attendance-text">{item.attendanceType}</span>
                                    <div className="attendance-actions">
                                        <button className="edit-btn" onClick={() => handleEdit(item)}>
                                            Edit
                                        </button>
                                        <button
                                            className="delete-btn"
                                            onClick={() => handleDelete(item.id)}
                                            style={{ display: "flex", alignItems: "center", gap: "5px" }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4>{editingId ? "Edit Sign-In Type" : "Add New Sign-In Type"}</h4>
                            <IoClose className="close-icon" onClick={() => setIsModalOpen(false)} />
                        </div>

                        <input
                            autoFocus={true}
                            type="text"
                            placeholder="Enter Sign-in type"
                            value={signInMethod}
                            onChange={(e) => {
                                setSignInMethod(e.target.value);
                                if (formSubmitted) setFormSubmitted(false);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSave();
                                }
                            }}
                            className={`signin-input ${formSubmitted && !signInMethod.trim() ? "input-error" : ""}`}
                        />

                        {formSubmitted && !signInMethod.trim() && <p className="error-text">Sign-in method is required</p>}

                        <div className="modal-buttons">
                            <button className="cancel-btn-attendance" onClick={() => setIsModalOpen(false)}>
                                Cancel
                            </button>
                            <button className="save-btn-attendance" onClick={handleSave} disabled={mutationLoading}>
                                {mutationLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : editingId ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <DailyNormConfiguration signInRequired={signInRequired} />
        </div>
    );
};

export default AttendanceDailyNorm;
